import { render, staticRenderFns } from "./AddGroupmembers.vue?vue&type=template&id=c6110480"
import script from "./AddGroupmembers.vue?vue&type=script&lang=js"
export * from "./AddGroupmembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports